<template lang="pug">
    v-card
        //crud-create-button(
            :action="generateLedger" text="Generar Libro Mayor"
            v-if="$can('CREATE_ACCOUNTING_LEDGER')"
            )
        model-data-table(
            :service="service" 
            :headers="headers"
            :filters="filters"
            @detail="submitShow($event.item.id)"
            @remove="submitDelete($event.item.id)"
            ref="refDTLedgeList"
            no-search
            remind-key='ledger-list'
            :showButton="() => $can('VIEW_DETAIL_ACCOUNTING_LEDGER')"
            :deleteButton="() => $can('DELETE_ACCOUNTING_LEDGER')"
            )
            template( slot='prepend' )
                v-btn( color='accent' large style='margin: -8px 0;' @click='generateLedger' ) generar libro mayor &nbsp;
                    v-icon add_circle
        dialog-generate-ledger(ref="refDialogGenerateLedger" @success="refreshDT")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CrudCreateButton } from '@/components/reusable_components'
import ModelDataTable from '@/components/reusable_components/next/ModelDataTable'
import HeadersLedger from './HeadersLedger'
import DialogGenerateLedger from './DialogGenerateLedger'
import { deleteLedger } from '@/services/api/ledger'
import UserService from '@/services/api/user'
import FiltersLedger from './FiltersLedger'
import AccLedger from '@/models/Accounting/AccLedger'
//-
export default {
    name: 'list-ledger',
    // props: {},
    data: function() {
        return {
            headers: HeadersLedger,
            filters: FiltersLedger,
            service: AccLedger,
            deleteId: 0,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        generateLedger: function() {
            this.$refs.refDialogGenerateLedger.open = true
        },
        submitShow: function(event) {
            this.$router.push(`/ledger/${event}`)
        },
        submitDelete: function(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar libro mayor?',
                ''
            )
            this.initSnackbar(payload)
            this.deleteId = event
        },
        // -- Data fetching
        getLedger: function() {
            const includes = ['g_user.hr_employee']
            const url = process.env.VUE_APP_API_ROUTE.concat(`/acc_ledger`)
        },
        // -- Data handling and transformations
        //-
        setFilterOptions(index, options) {
            this.filters[index].options = options
        },
        //-
        mapUserToFilter: ({ hr_employee, id }) => ({
            text: [
                hr_employee.names,
                hr_employee.last_name1,
                hr_employee.last_name2,
            ].join(' '),
            value: id,
        }),
        // -- Validations and Error handling
        refreshDT: function() {
            this.$refs.refDTLedgeList.refresh()
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deleteLedger(this.deleteId)
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Libro mayor eliminado con éxito',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTLedgeList.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-create-button': CrudCreateButton,
        'model-data-table': ModelDataTable,
        'dialog-generate-ledger': DialogGenerateLedger,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount: async function() {
        let users = await UserService.fetchAll()
        this.setFilterOptions(0, users.map(this.mapUserToFilter))
    },
    mounted: function() {
        this.setTitleTopBar('Libro mayor')
        this.getLedger()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ACCOUNTING_LEDGER')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>